import React from "react";
import { Link } from "react-router-dom";
import { Layout, Menu, Button, Dropdown } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import * as RoutePath from "../pages/routePath";
import LanguageSelector from "./LanguageSelector";

const { Header } = Layout;

const MobileNavbar = () => {
  const { t } = useTranslation("common");

  const dropdownMenu = (
    <Menu>
      <Menu.Item key="1">
        <Link to={RoutePath.HomePath}>{t("navbar.home")}</Link>
      </Menu.Item>
      <Menu.Item key="2">
        <Link to={RoutePath.EducationPath}>{t("navbar.education")}</Link>
      </Menu.Item>
      <Menu.Item key="3">
        <Link to={RoutePath.NewsPath}>{t("navbar.news")}</Link>
      </Menu.Item>
      <Menu.Item key="4">
        <Link to={RoutePath.CampPath}>{t("navbar.camp")}</Link>
      </Menu.Item>
      <Menu.Item key="5">
        <Link to={RoutePath.AboutPath}>{t("navbar.about")}</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="layout">
      <Header className="sticky inset-x-0 top-0 z-50 bg-white shadow-md">
        <div className="flex justify-between items-center px-4 h-16">
          <div className="flex-none">
            <div className="text-green-500 text-2xl whitespace-nowrap overflow-hidden text-overflow-ellipsis">
              {t("navbar.schoolNameZh")}
            </div>
            <div className="text-gray-400 text-lg whitespace-nowrap overflow-hidden text-overflow-ellipsis">
              {t("navbar.schoolNameEn")}
            </div>
          </div>

          {/* Desktop menu */}
          <div className="flex-grow hidden md:flex">
            <Menu mode="horizontal" theme="light" className="w-full justify-end">
              <Menu.Item key="1">
                <Link to={RoutePath.HomePath} className="text-base">
                  {t("navbar.home")}
                </Link>
              </Menu.Item>
              <Menu.Item key="2">
                <Link to={RoutePath.EducationPath} className="text-base">
                  {t("navbar.education")}
                </Link>
              </Menu.Item>
              <Menu.Item key="3">
                <Link to={RoutePath.NewsPath} className="text-base">
                  {t("navbar.news")}
                </Link>
              </Menu.Item>
              <Menu.Item key="4">
                <Link to={RoutePath.CampPath} className="text-base">
                  {t("navbar.camp")}
                </Link>
              </Menu.Item>
              <Menu.Item key="5">
                <Link to={RoutePath.AboutPath} className="text-base">
                  {t("navbar.about")}
                </Link>
              </Menu.Item>
            </Menu>
          </div>

          {/* Language selector + mobile menu button */}
          <div className="flex items-center gap-2">
            {/* Show LanguageSelector on all screen sizes */}
            <LanguageSelector />

            {/* Mobile dropdown */}
            <Dropdown overlay={dropdownMenu} trigger={["click"]} className="md:hidden">
              <Button type="link" onClick={(e) => e.preventDefault()}>
                <MenuOutlined />
              </Button>
            </Dropdown>
          </div>
        </div>
      </Header>
    </Layout>
  );
};

export default MobileNavbar;
